export const stepOneData = [
  {
    stepOneHeading: "1. Understand Personal Loan Debt Consolidation",
    paraOne:
      "Personal loan debt consolidation involves combining multiple small or large personal loans into a single loan with better repayment terms. This simplifies repayment schedules, helps reduce overall interest payments, and frees you from managing multiple due dates and varying EMIs.",

    tip: "Consolidating personal loans not only reduces financial stress but can also improve your credit score by ensuring timely and consistent repayments.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2. Evaluate Your Current Financial Situation",
    paraOne: "Before consolidating, assess your personal loan portfolio:",

    // paraThree after "How much do you need to borrow for debt consolidation?"

    financialHealthList: [
      {
        head: " List All Loans: ",
        info: "Include outstanding amounts, EMIs, and due dates.",
      },
      {
        head: "Calculate Total Debt: ",
        info: "Sum up all outstanding balances.",
      },
      {
        head: "Evaluate Monthly Payments: ",
        info: "Understand how much you are currently paying across all loans.",
      },
      {
        head: "Review Interest Rates: ",
        info: "Identify high-interest personal loans that can be consolidated.",
      },
    ],
    tip: "Knowing your financial standing helps you identify how consolidation can save you money.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Identify Eligible Personal Loans for Consolidation",
    paraOne:
      "In India, many individuals have taken personal loans through different apps or financial institutions. Personal loans with high interest rates and shorter tenures are ideal candidates for consolidation.",
  },
];

export const stepFourData = [
  {
    stepFourHeading:
      "4. Use Minemi’s Personal Loan Debt Consolidation Calculator",
    paraOne:
      "Input your existing personal loans into the calculator to estimate:",

    debtCalculatorList: [
      {
        head: "New EMI Amount: ",
        info: "Your expected monthly payment after consolidation.",
      },
      {
        head: "Total Interest Payable: ",
        info: "The cumulative interest over the loan tenure.",
      },
      {
        head: "Total Repayment Amount: ",
        info: "The sum of principal and interest to be repaid.",
      },
    ],

    debtTable: {
      headings: [
        {
          head: "Loan Type",
        },
        {
          head: "Amount (₹)",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Months)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          loanType: "Personal Loan 1",
          amount: "₹50,000",
          interest: "20%",
          tenure: "12",
          emi: "₹4,621",
          repayment: "₹55,452",
        },
        {
          loanType: "Personal Loan 2",
          amount: "₹1,50,000",
          interest: "18%",
          tenure: "24",
          emi: "₹7,495",
          repayment: "₹1,79,880",
        },
        {
          loanType: "Personal Loan 3",
          amount: "₹2,00,000",
          interest: "16%",
          tenure: "36",
          emi: "₹7,033",
          repayment: "₹2,53,188",
        },
      ],
    },

    consolidationTable: {
      headings: [
        {
          head: "Amount (₹)",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          amount: "₹4,00,000",
          interest: "12%",
          tenure: "36",
          emi: "₹13,301",
          repayment: "₹4,19,460",
        },
      ],
    },
    tip: "Consolidating personal loans with a lower interest rate can reduce your EMI significantly, saving both money and time.",
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Compare Consolidation Loan Offers",
    paraOne: "When choosing a consolidation loan:",

    list: [
      {
        head: "Compare Interest Rates: ",
        info: "Aim for a loan with a lower interest rate than your current personal loans.",
      },
      {
        head: "Evaluate Tenures: ",
        info: "Select a tenure that balances EMI affordability and total interest paid.",
      },
      {
        head: "Account for Processing Fees: ",
        info: "Check for hidden charges that may affect your savings.",
      },
    ],
    tip: "Use Minemi’s platform to compare loan offers and find the best terms tailored to your needs.",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. Apply for a Personal Loan Debt Consolidation Loan",
    paraOne: "Once you’ve found a suitable loan:",

    list: [
      {
        head: "Gather Documents: ",
        info: "Include proof of income, personal identification, and statements for existing loans.",
      },
      {
        head: "Submit the Application: ",
        info: "Many lenders offer seamless online application processes.",
      },
      {
        head: "Await Approval: ",
        info: "Your credit profile and repayment history will determine approval and loan terms.",
      },
    ],
  },
];

export const stepSevenData = [
  {
    stepSevenHeading: "7. Close Existing Personal Loans",
    paraOne: "Upon approval:",

    list: [
      {
        head: "Clear Outstanding Balances: ",
        info: "Use the consolidated loan funds to pay off all existing personal loans.",
      },
      {
        head: " Obtain Closure Letters: ",
        info: "Ensure you get official confirmation of loan closure from previous lenders.",
      },
    ],
  },
];

export const stepsEightData = [
  {
    stepsEightHeading: "8. Manage Your New Loan Effectively",
    paraOne: "To maximize the benefits of debt consolidation:",

    list: [
      {
        head: "Timely Payments: ",
        info: "Set up auto-debit or reminders to avoid missed EMIs.",
      },
      {
        head: "Track Expenses: ",
        info: "Adjust your monthly budget to accommodate the new EMI.",
      },
      {
        head: "Avoid New Loans:",
        info: "Resist the temptation to take new loans during the repayment period.",
      },
    ],
  },
];
export const stepsNineData = [
  {
    stepsNineHeading: "9. Monitor and Improve Your Credit Score",
    paraOne:
      "Regularly checking your credit score helps track improvements from timely payments. A higher credit score can open up better financial opportunities in the future.",

    tip: "Use Minemi’s tools to monitor your credit score and receive personalized financial insights.",
  },
];
